import { useState, useEffect,useRef } from 'react';
import {
  Table,
  Button,
  Dialog,
  Form,
  Input,
  Textarea,
  Popconfirm,
  Tag,
  Space,
  MessagePlugin,
  Radio,
} from 'tdesign-react';
import { AddIcon, EditIcon, DeleteIcon, CheckIcon, CloseIcon, SettingIcon } from 'tdesign-icons-react';
import { supplierApi } from '../../api';
import type { Supplier } from '../../types';
import CoverImageUploader from '../../components/CoverImageUploader';

const statusOptions = [
  { label: '待审核', value: 0, theme: 'warning' },
  { label: '已通过', value: 1, theme: 'success' },
  { label: '已拒绝', value: 2, theme: 'danger' },
];
let ServiceSupplier =  {
  id: '',
  companyName: '',
  fixedRatio: '',
  fixedBaseAmount: '',
  feeRatioType: 0,
  minRatio: '',
  maxRatio: '',
  feeBaseType: 0,
}
export default function SupplierManage() {
  const [data, setData] = useState<Supplier[]>([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [dialogVisible, setDialogVisible] = useState(false);
  const [serviceDialogVisible, setServiceDialogVisible] = useState(false);
  const [auditDialogVisible, setAuditDialogVisible] = useState(false);
  const [editingSupplier, setEditingSupplier] = useState<Supplier | null>(null);
  const [auditingSupplier, setAuditingSupplier] = useState<Supplier | null>(null);
  const [serviceSupplier, setServiceSupplier] = useState(ServiceSupplier);
  const [service, setFeeBaseType] = useState('');
  const [businessLicenseUrl, setBusinessLicenseUrl] = useState('');
  const [auditRemark, setAuditRemark] = useState('');
  const formRef = useRef<any>(null);
  const serviceFormRef = useRef<any>(null);

  const columns = [
    { colKey: 'id', title: 'ID', width: 80 },
    { colKey: 'companyName', title: '公司名称' },
    { colKey: 'companyCode', title: '公司编码', width: 120 },
    { colKey: 'contactName', title: '联系人', width: 100 },
    { colKey: 'contactPhone', title: '联系电话', width: 140 },
    {
      colKey: 'status',
      title: '状态',
      width: 100,
      cell: ({ row }: any) => {
        const status = statusOptions.find(s => s.value === row.status);
        return <Tag theme={status?.theme as any}>{status?.label || '未知'}</Tag>;
      },
    },
    { colKey: 'createTime', title: '创建时间', width: 180 },
    {
      colKey: 'action',
      title: '操作',
      width: 380,
      cell: ({ row }: any) => (
        <Space>
          {row.status === 0 && (
            <>
              <Button
                theme="success"
                variant="text"
                icon={<CheckIcon />}
                onClick={() => handleAudit(row, 1)}
              >
                通过
              </Button>
              <Button
                theme="danger"
                variant="text"
                icon={<CloseIcon />}
                onClick={() => handleAudit(row, 2)}
              >
                拒绝
              </Button>
            </>
          )}
          <Button
            theme="primary"
            variant="text"
            icon={<EditIcon />}
            onClick={() => handleEdit(row)}
          >
            编辑
          </Button>
          <Popconfirm
            content="确定要删除该供应商吗？"
            onConfirm={() => handleDelete(row.id)}
          >
            <Button theme="danger" variant="text" icon={<DeleteIcon />}>
              删除
            </Button>
          </Popconfirm>
          <Button
            theme="primary"
            variant="text"
            icon={<SettingIcon />}
            onClick={() => handleService(row)}
          >
            服务费
          </Button>
        </Space>
      ),
    },
  ];

  const fetchData = async (page = pagination.current, pageSize = pagination.pageSize) => {
    setLoading(true);
    try {
      const res = await supplierApi.getList({ pageNum: page, pageSize });
      if (res.code === 200) {
        setData(res.data.list);
        setPagination({
          current: res.data.pageNum,
          pageSize: res.data.pageSize,
          total: res.data.total,
        });
      }
    } catch (err) {
      MessagePlugin.error('加载数据失败');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleService = async (supplier: Supplier) => {
    const res = await supplierApi.getFeeConfig(supplier.id)
    if(res.data){
      let params = res.data
      setServiceSupplier({
        id: supplier.id + '',
        companyName: supplier.companyName,
        feeBaseType: params.feeBaseType ,
        fixedBaseAmount: params.feeBaseType == 3 ? params.feeBaseAmount + '' : '' ,
        feeRatioType: params.feeRateType,
        minRatio: params.feeRateType == 2 ? params.feeRateMin + '' : '',
        maxRatio: params.feeRateType == 2 ? params.feeRateMax + '' : '',
        fixedRatio: params.feeRateType == 1 ? params.feeRateMin + '' : '',
      })
    }else{
      setServiceSupplier({
        ...ServiceSupplier,
        id: supplier.id + '',
        companyName: supplier.companyName
      });
    }
    setServiceDialogVisible(true);
  };

  const handleServiceClose = () => {
    setServiceDialogVisible(false);
    setServiceSupplier(ServiceSupplier);
  };
  
  const handleServiceSubmit = async () => {
    try { 
      if(!serviceSupplier.feeBaseType) {
        MessagePlugin.error('请选择服务费类型');
        return;
      }
      if(serviceSupplier.feeBaseType && serviceSupplier.feeBaseType == 3 && !serviceSupplier.fixedBaseAmount) {
        MessagePlugin.error('请填写固定金额');
        return;
      }
      if(!serviceSupplier.feeRatioType){
        MessagePlugin.error('请选择服务费比例类型');
        return;
      }
      if(serviceSupplier.feeRatioType && serviceSupplier.feeRatioType == 1 && !serviceSupplier.fixedRatio) {
        MessagePlugin.error('请填写固定比例');
        return;
      }
      if(serviceSupplier.feeRatioType && serviceSupplier.feeRatioType == 2 && (!serviceSupplier.minRatio || !serviceSupplier.maxRatio)) {
        MessagePlugin.error('请填写最小比例和最大比例');
        return;
      }

      const submitData = {
        feeBaseType: serviceSupplier.feeBaseType,
        feeBaseAmount: serviceSupplier.fixedBaseAmount || 0,
        feeRateType: serviceSupplier.feeRatioType,
        feeRateMin: serviceSupplier.feeRatioType == 1 ? serviceSupplier.fixedRatio : serviceSupplier.minRatio  ? serviceSupplier.minRatio : 0,
        feeRateMax: serviceSupplier.maxRatio  ? serviceSupplier.maxRatio : 0,
      };
      let res = await supplierApi.updateFeeConfig(serviceSupplier.id, submitData);
      if(res.code === 200){
        MessagePlugin.success('服务费设置成功');
        handleServiceClose()
        fetchData();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const resetFormState = () => {
    setEditingSupplier(null);
    setBusinessLicenseUrl('')
    // 如果 formRef 有 reset 方法，也可以调用
    if (formRef.current) {
      formRef.current.reset();
    }
  };
  const handleAdd = () => {
    resetFormState()
    setDialogVisible(true);
  };

  const handleEdit = (supplier: Supplier) => {
    setEditingSupplier(supplier);
    setBusinessLicenseUrl(supplier.businessLicense || '');
    setDialogVisible(true);
  };

  const handleAudit = (supplier: Supplier, status: number) => {
    setAuditingSupplier(supplier);
    setAuditRemark('');
    setAuditDialogVisible(true);
  };

  const handleAuditSubmit = async (status: number) => {
    if (!auditingSupplier) return;
    
    try {
      const res = await supplierApi.audit({
        id: auditingSupplier.id,
        status,
        remark: auditRemark,
      });
      
      if (res.code === 200) {
        MessagePlugin.success(status === 1 ? '审核通过' : '审核拒绝');
        setAuditDialogVisible(false);
        fetchData();
      } else {
        MessagePlugin.error(res.message || '审核失败');
      }
    } catch (err) {
      MessagePlugin.error('审核失败');
    }
  };

  const handleDelete = async (id: number) => {
    try {
      const res = await supplierApi.delete(id);
      if (res.code === 200) {
        MessagePlugin.success('删除成功');
        fetchData();
      } else {
        MessagePlugin.error(res.message || '删除失败');
      }
    } catch (err) {
      MessagePlugin.error('删除失败');
    }
  };

  const handleSubmit = async () => {
    try {
      // 【修复】通过 formRef 获取实例并验证
      const result = await formRef.current?.validate();
      
      // validate 返回 true 表示成功，或者包含错误信息
      if (result !== true) {
        return;
      }
      const values = formRef.current?.getFieldsValue(true) || {};
      const submitData = {
        ...values,
        businessLicense: businessLicenseUrl,
      };
      let res;
      if (editingSupplier) {
        res = await supplierApi.update(editingSupplier.id, submitData);
      } else {
        res = await supplierApi.create(submitData);
      }

      if (res.code === 200) {
        MessagePlugin.success(editingSupplier ? '更新成功' : '创建成功');
        setDialogVisible(false);
        setEditingSupplier(null)
        fetchData();
      } else {
        MessagePlugin.error(res.message || '操作失败');
      }
    } catch (err) {
      console.error(err);
    }
  };
  const handRadioChange = (value) => {
    console.log(value,'value');
    setServiceSupplier({
      ...serviceSupplier,
      feeBaseType: value,
      fixedBaseAmount: '',
      feeRatioType: 0,
      minRatio: '',
      maxRatio: '',
      fixedRatio:''
    });
  }
  const handfeeChange = (value) => {
    setServiceSupplier({
      ...serviceSupplier,
      feeRatioType: value,
      minRatio: '',
      maxRatio: '',
      fixedRatio:''
    });
  }
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">供应商档案</h1>
        <Button theme="primary" icon={<AddIcon />} onClick={handleAdd}>
          新增供应商
        </Button>
      </div>

      <Table
        data={data}
        columns={columns}
        rowKey="id"
        loading={loading}
        pagination={{
          ...pagination,
          onChange: (pageInfo: any) => fetchData(pageInfo.current, pageInfo.pageSize),
        }}
      />

      {/* 编辑对话框 */}
      <Dialog
        header={editingSupplier ? '编辑供应商' : '新增供应商'}
        visible={dialogVisible}
        onClose={() => {
          setDialogVisible(false)
          resetFormState();
        }}
        onConfirm={handleSubmit}
        width={600}
        key={editingSupplier ? `edit-${editingSupplier.id}` : 'add-new'}
      >
        <Form ref={formRef}
            initialData={editingSupplier || {}}   labelWidth={100}>
          <Form.FormItem label="公司名称" name="companyName" rules={[{ required: true, message: '请输入公司名称' }]}>
            <Input placeholder="请输入公司名称" />
          </Form.FormItem>
          <Form.FormItem label="公司编码" name="companyCode">
            <Input placeholder="请输入公司编码" />
          </Form.FormItem>
          <Form.FormItem label="联系人" name="contactName" rules={[{ required: true, message: '请输入联系人' }]}>
            <Input placeholder="请输入联系人" />
          </Form.FormItem>
          <Form.FormItem label="联系电话" name="contactPhone" rules={[{ required: true, message: '请输入联系电话' }]}>
            <Input placeholder="请输入联系电话" />
          </Form.FormItem>
          <Form.FormItem label="联系邮箱" name="contactEmail">
            <Input placeholder="请输入联系邮箱" />
          </Form.FormItem>
          <Form.FormItem label="营业执照" name="businessLicense">
            <CoverImageUploader 
                value={businessLicenseUrl} 
                onChange={(val) => {
                  setBusinessLicenseUrl(Array.isArray(val) ? val[0] : val);
                }} 
                simple
              />
          </Form.FormItem>
          <Form.FormItem label="经营范围" name="businessScope">
            <Textarea placeholder="请输入经营范围" rows={3} />
          </Form.FormItem>
          <Form.FormItem label="公司地址" name="address">
            <Input placeholder="请输入公司地址" />
          </Form.FormItem>
        </Form>
      </Dialog>

      {/* 审核对话框 */}
      <Dialog
        header="审核供应商"
        visible={auditDialogVisible}
        onClose={() => setAuditDialogVisible(false)}
        footer={
          <div className="flex justify-end gap-3">
            <Button onClick={() => setAuditDialogVisible(false)}>取消</Button>
            <Button theme="danger" onClick={() => handleAuditSubmit(2)}>拒绝</Button>
            <Button theme="success" onClick={() => handleAuditSubmit(1)}>通过</Button>
          </div>
        }
      >
        <div className="py-4">
          <p className="mb-4">供应商：{auditingSupplier?.companyName}</p>
          <div className="mb-2">审核备注：</div>
          <Textarea
            value={auditRemark}
            onChange={(value) => setAuditRemark(value)}
            placeholder="请输入审核备注（可选）"
            rows={3}
          />
        </div>
      </Dialog>

      {/* 服务费设置对话框 */}
      <Dialog
        header="服务费设置"
        visible={serviceDialogVisible}
        onClose={handleServiceClose}
        onConfirm={handleServiceSubmit}
        width={900}
      >
        <div className="py-4">
            <p className="mb-6">供应商：{serviceSupplier?.companyName}</p>

            <div className="border-b pb-4 mb-6">
              <h3 className="font-medium mb-4">1 您同意选择第【 】种方式确定技术服务服务费基数：</h3>
              <Radio.Group value={serviceSupplier.feeBaseType} onChange={(value) => handRadioChange(value)}>
                <div className="flex flex-col gap-2">
                  <Radio value={1}>【1】您与买家的线下成交合同金额</Radio>
                  <Radio value={2}>【2】本平台提供给您的订单成交额</Radio>
                  <Radio value={3}>
                    <div className="flex items-center gap-2">
                      <span>
                        【3】本协议确定的固定基数即
                      </span>
                      <div className='border-b'>
                        <Input 
                          value={serviceSupplier.fixedBaseAmount} 
                          borderless 
                          disabled={Number(serviceSupplier.feeBaseType) === 3 ? false : true}
                          placeholder="请输入固定基数金额"
                          onChange={(value) => setServiceSupplier({ ...serviceSupplier, fixedBaseAmount: value })}
                        />
                      </div>
                    </div>
                  </Radio>
                </div>
              </Radio.Group>
            </div>

            <div className="border-b pb-4 mb-6">
              <h3 className="font-medium mb-4">2 您同意选择第【 】种方式确定撮合服务服务费比例：</h3>
              <Radio.Group value={serviceSupplier.feeRatioType} onChange={(value) => handfeeChange(value)}>
                  <Radio value={1}>
                    <div className="flex items-center gap-2">
                      <span>
                        【1】本合同约定的固定比例:
                      </span>
                      <div className='border-b flex items-center gap-2'>
                        <Input 
                          value={serviceSupplier.fixedRatio} 
                          borderless 
                          placeholder="请输入固定比例"
                          disabled={Number(serviceSupplier.feeRatioType) === 1 ? false : true}
                          onChange={(value) => setServiceSupplier({ ...serviceSupplier, fixedRatio: value })}
                        />%
                      </div>
                    </div>
                  </Radio>
                  <Radio value={2}>
                    <div className="flex items-center gap-2">
                      <span>
                        【2】按照订单量设置阶梯浮动比例，比例区间为:
                      </span>
                      <div className="flex items-center gap-2">
                        <div className='border-b flex items-center gap-2'>
                          <Input 
                            value={serviceSupplier.minRatio} 
                            borderless 
                            disabled={Number(serviceSupplier.feeRatioType) === 2 ? false : true}
                            placeholder="请输入最小比例"
                            onChange={(value) => setServiceSupplier({ ...serviceSupplier, minRatio: value })}
                          />%
                        </div>
                        至
                        <div className='border-b flex items-center gap-2'>
                          <Input 
                            value={serviceSupplier.maxRatio} 
                            borderless 
                            disabled={Number(serviceSupplier.feeRatioType) === 2 ? false : true}
                            placeholder="请输入最大比例"
                            onChange={(value) => setServiceSupplier({ ...serviceSupplier, maxRatio: value })}
                          />%
                        </div>
                      </div>
                    </div>
                  </Radio>
                  <Radio value={3}>【3】为每笔订单单独设置比例，具体比例以您在平台上提交并经过我方审核的为准</Radio>
                </Radio.Group>
            </div>
          </div>
      </Dialog>
    </div>
  );
}
